<template lang="pug">
  .modal-card
    .modal-card-head
      header {{ title }}
    .modal-card-body
      b-field(label="ユーザー名" label-for="userName")
        b-input#userName(
          ref="mail"
          v-model="userName.value"
          type="text"
          required
          size="is-medium"
          maxlength="20"
          @input="validateUserName")
      b-field(label="Googleアカウント（メールアドレス）" label-for="googleAccount" :type="mail.labelType" :message="mail.validationMessage")
        b-input#googleAccount(
          ref="mail"
          v-model="mail.value"
          type="email"
          required
          expanded
          size="is-medium"
          maxlength="254"
          :use-html5-validation="false"
          @blur="validateMail")
      b-field(label="権限" label-for="role")
        b-select#role(
          v-model="role.value"
          size="is-medium"
          @input="validateRole")
          option(v-for="role in roleList" :value="role.value" :key="role.value") {{ role.name }}
    .modal-card-foot
      b-button(
        v-if="modalType === 'add'"
        type="is-info"
        size="is-medium"
        :loading="form.isLoading"
        :disabled="!form.isCompleted"
        @click="addUser()") 追加する
      b-button(
        v-else-if="modalType === 'edit'"
        type="is-info"
        size="is-medium"
        :loading="form.isLoading"
        :disabled="!form.isCompleted"
        @click="updateUser()") 更新する
</template>

<script>
export default {
  name: 'UserModal',
  props: [
    'isModalActive',
    'modalType',
    'userData',
  ],
  data: function(){
    return {
      title: '',

      form: {
        isCompleted: false,
        isLoading: false
      },
      userName: {
        value: '',
        status: ''
      },
      mail: {
        value: '',
        status: '',
        labelType: '',
        validationMessage: ''
      },
      role: {
        value: '',
        status: ''
      },
      roleList: [
        {
          value: 0,
          name: '一般ユーザー'
        },
        {
          value: 1,
          name: '管理者'
        }
      ],
      errorMessage: {
        userName: {
          characterLimit: 'ユーザー名は20文字以内で入力してください。',
          empty: 'ユーザー名を入力してください。'
        },
        mail: {
          alreadyRegistered: 'このメールアドレスは既に登録されています。',
          characterLimit: 'メールアドレスは254文字以内で入力してください。',
          empty: 'メールアドレスを入力してください。',
          invalid: 'メールアドレスを正しく入力してください。'
        },
        role: {
          empty: '権限を選択してください。'
        },
        general: 'ユーザーの追加・更新に失敗しました。時間を空けて、もう一度お試しください。'
      }
    }
  },
  created() {
  },
  mounted() {
    if( this.modalType === 'edit' ) {
      this.title = 'ユーザーの編集'

      this.userName.value = this.userData.name
      this.mail.value = this.userData.mail
      this.role.value = this.userData.role

      this.validateUserName()
      this.validateMail()
    } else if ( this.modalType === 'add' ) {
      this.title = '新規ユーザーの追加'

      this.role.value = 0
    }

    this.validateRole()
  },
  watch: {
    'mail.value'(value) {
      if( value !== '' && this.isMailCorrectFormat() ) {
        this.mail.status = 'isCompleted'
      } else {
        this.mail.status = ''
        this.mail.labelType = ''
        this.mail.validationMessage = ''
      }

      this.checkForm()
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    validateUserName(){
      this.userName.status = ( this.userName.value !== '' ) ? 'isCompleted' : 'isError'

      this.checkForm()
    },
    validateMail(){
      if( this.mail.value === '' ) {
        this.mail.status = 'isError'
        this.mail.labelType = 'is-danger'
        this.mail.validationMessage = 'このフィールドを入力してください。'
      } else if( !this.isMailCorrectFormat() ) {
        this.mail.status = 'isError'
        this.mail.labelType = 'is-danger'
        this.mail.validationMessage = '正しいメールアドレスの形式で入力してください。'
      }

      this.checkForm()
    },
    validateRole(){
      this.role.status = ( this.role.value !== '' ) ? 'isCompleted' : 'isError'

      this.checkForm()
    },
    isMailCorrectFormat() {
      const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      return regexp.test(this.mail.value);
    },
    checkForm() {
      this.form.isCompleted = ( this.userName.status === 'isCompleted' && this.mail.status === 'isCompleted' && this.role.status === 'isCompleted' ) ? true : false
    },
    async addUser() {
      try {
        this.form.isLoading = true

        const data_obj = {
          name: this.userName.value,
          mail: this.mail.value,
          role: this.role.value
        }

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.USERS,
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('ユーザー ' + this.userName.value + ' を追加しました')

          this.$emit('setNewData')

          this.closeModal()
        }else{
          let errorMessage = new Array()

          for(let i =0; i < r.errors.length; i++){ // updateUserと内容合わせる
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if( r.errors[i].status == 91 ) {
              errorMessage.push(this.errorMessage.userName.empty)
            } else if( r.errors[i].status == 92 ) {
              errorMessage.push(this.errorMessage.userName.characterLimit)
            } else if( r.errors[i].status == 93 ) {
              errorMessage.push(this.errorMessage.mail.empty)
            } else if( r.errors[i].status == 94 ) {
              errorMessage.push(this.errorMessage.mail.invalid)
            } else if( r.errors[i].status == 95 ) {
              errorMessage.push(this.errorMessage.mail.alreadyRegistered)
            } else if( r.errors[i].status == 96 ) {
              errorMessage.push(this.errorMessage.mail.characterLimit)
            } else if( r.errors[i].status == 97 ) {
              errorMessage.push(this.errorMessage.role.empty)
            } else {
              errorMessage.push(this.errorMessage.general)
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.form.isLoading = false
      }
    },
    async updateUser() {
      try {
        this.form.isLoading = true

        const data_obj = {
          name: this.userName.value,
          mail: this.mail.value,
          role: this.role.value
        }

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.USERS_.replace(':id', this.userData.id),
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('ユーザー '+ this.userName.value +' の情報を更新しました')

          this.$emit('setNewData')

          this.closeModal()
        } else {
          let errorMessage = new Array()

          for(let i =0; i < r.errors.length; i++){ // addUserと内容合わせる
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if( r.errors[i].status == 91 ) {
              errorMessage.push(this.errorMessage.userName.empty)
            } else if( r.errors[i].status == 92 ) {
              errorMessage.push(this.errorMessage.userName.characterLimit)
            } else if( r.errors[i].status == 93 ) {
              errorMessage.push(this.errorMessage.mail.empty)
            } else if( r.errors[i].status == 94 ) {
              errorMessage.push(this.errorMessage.mail.invalid)
            } else if( r.errors[i].status == 95 ) {
              errorMessage.push(this.errorMessage.mail.alreadyRegistered)
            } else if( r.errors[i].status == 96 ) {
              errorMessage.push(this.errorMessage.mail.characterLimit)
            } else if( r.errors[i].status == 97 ) {
              errorMessage.push(this.errorMessage.role.empty)
            } else {
              errorMessage.push(this.errorMessage.general)
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.form.isLoading = false
      }
    }
  }
}
</script>
